<template>
    <div>
      <div class="compare-selected">
        <p class="s-con">已选择产品(您已选择{{selectedNum}}/3,最多可选择3件)</p>
        <div class="s-list">
          <div class="s-item" v-for="item in list" v-if="item.selected==1">
            <div class="s-img">
              <img :src="BASE_URL+item.imagePath">
            </div>
            <img @click="selectSku(item.sku8D,0)" class="s-close" src="../assets/image/close-blue.png">
            <p class="s-title">{{item.enName}}</p>
          </div>
          <div class="s-item empty">

          </div>
        </div>
      </div>
      <div class="compare-list">
        <div @click="selectSku(item.sku8D,1)" class="compare-item" v-for="item in list">
          <div :class="[item.selected==1?'active':'','c-img']">
            <img :src="BASE_URL+item.imagePath">
          </div>
          <p class="c-title">{{item.enName}}</p>
        </div>
      </div>
      <div @click="ensure" class="compare-ensure">
        <p>确认选择</p>
      </div>
    </div>
</template>
<style scoped lang="less">
  .compare-selected {
    padding: 10px 18px 13px 18px;
    background-color: #efefef;
    font-size: 9px;
    color: #999999;
    .s-con {

    }
    .s-list {
      display: flex;
      align-items: flex-start;
      padding-top: 10px;
      overflow-x: hidden;
      .s-item {
        width: 65px;
        position: relative;
        margin-right: 7%;
        .s-img {
          width: 100%;
          height: 65px;
          background-color: #ffffff;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 80%;
          }
        }
        .s-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .s-close {
          position: absolute;
          right: -10px;
          top: -6px;
          width: 19px;
          height: 19px;
        }
        &.empty {
          height: 65px;
          border: 1px dotted #8d8d8d;
        }
      }
    }
  }
  .compare-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 23px 18px 52px 18px;
    .compare-item {
      width: 30%;
      text-align: center;
      margin-bottom: 15px;
      margin-right: 5%;
      &:nth-of-type(3n) {
        margin-right: 0px;
      }
      .c-img {
        width: 100%;
        height: 0;
        padding-bottom: 50%;
        padding-top: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #9f9f9f;
        &.active {
          border: 1px solid rgb(30,149,241);
        }
        img {
          width: 80%;
        }
      }
      .c-title {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .compare-ensure {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 52px;
    line-height: 52px;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    background-color: #1b81f1;
  }
</style>
<script>

    export default{
        data(){
            return{
                api: this.$store.state.api,
                BASE_URL: BASE_URL,
                list: [],
                selectedNum: 0,
                eightD: this.$route.query.eightD
            }
        },
        components:{

        },
        created() {
          this.compareList();
        },

        methods: {
          selectSku(sku,select) {
            if(this.selectedNum>=3&&select==1) {
              return;
            }
            var arr = this.list;
            for(var i=0;i<arr.length;i++){
              if(arr[i].sku8D==sku) {
                if(arr[i].selected!=select) {
                  select==1?this.selectedNum+=1:this.selectedNum-=1;
                }
                arr[i].selected = select;
                this.$set(this.list,i,arr[i]);
              }
            }

          },
          compareList() {
            let url = this.api.product.findCompareList();
            this.$http.get(url,{
              params: {
                eightD: this.eightD
              }
            })
            .then(res=>{
              if(res.data.result&&res.data.code=='00') {
                this.list = res.data.returnData.OutCompareList;
                for(var i=0;i<this.list.length;i++){
                  this.list[i].selected = 0;
                }
              }
            })
            .catch(res=>{
              res = {"result":true,"code":"00","returnData":{"OutCompareList":[{"sku8D":"P13066005","enName":"HT-MT500/白","cnName":"HT-MT500 乳白 支持高解析度音频 迷你无线家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_mt500/product/img_ht_mt500_w_0.jpg"},{"sku8D":"P13065905","enName":"HT-MT500/黑","cnName":"HT-MT500 炭黑 支持高解析度音频 迷你无线家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_mt500/product/img_ht_mt500_b_0.jpg"},{"sku8D":"P13066405","enName":"HT-CT800","cnName":"HT-CT800系列 蓝牙家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_ct800/product/img_ht_ct800_b_0.jpg"},{"sku8D":"P13045705","enName":"HT-CT180","cnName":"HT-CT180系列 家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_ct180/img_ct180_b_0.jpg"},{"sku8D":"P13066705","enName":"HT-CT290/白","cnName":"HT-CT290 白 蓝牙家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_ct290/product/img_ht_ct290_w_0.jpg"},{"sku8D":"P13066605","enName":"HT-CT290/黑","cnName":"HT-CT290 黑 蓝牙家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_ct290/product/img_ht_ct290_b_0.jpg"},{"sku8D":"P13065305","enName":"HT-CT390","cnName":"HT-CT390系列 蓝牙家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_ct390/product/img_ht_ct390_b_0.jpg"},{"sku8D":"P13065105","enName":"HT-NT5","cnName":"HT-NT5系列 蓝牙家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_nt5/product/img_ht_nt5_b_0.jpg"},{"sku8D":"P13066305","enName":"HT-ST5000","cnName":"HT-ST5000系列 7.1.2声道环绕家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_st5000/product/img_ht_st5000_b_0.jpg"},{"sku8D":"P13066205","enName":"HT-MT300/白","cnName":"HT-MT300 乳白 迷你无线家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_mt300/product/img_ht_mt300_w_0.jpg"},{"sku8D":"P13066105","enName":"HT-MT300/黑","cnName":"HT-MT300 炭黑 迷你无线家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_mt300/product/img_ht_mt300_b_0.jpg"},{"sku8D":"P82818505","enName":"BDV-N9200W","cnName":"BDV-N9200W高解析度音频家庭影院9200W系列黑色","imagePath":"/content/dam/sonystyle/products/home_theater/bdv_n9200w/product/img_9200_b_0.jpg"},{"sku8D":"P82818605","enName":"BDV-N9200WL","cnName":"BDV-N9200WL高解析度音频家庭影院9200WL系列白色","imagePath":"/content/dam/sonystyle/products/home_theater/bdv_n9200w/product/img_9200_w_0.jpg"},{"sku8D":"P13064705","enName":"HT-RT5","cnName":"HT-RT5系列 5.1声道家庭影音系统","imagePath":"/content/dam/sonystyle/products/home_theater/ht_rt5/product/img_ht_rt5_b_0.jpg"}]}};
              if(res.result&&res.code=='00') {
                this.list = res.returnData.OutCompareList;
                for(var i=0;i<this.list.length;i++){
                  this.list[i].selected = 0;
                }
              }
            })
          },
          ensure() {
            if(this.selectedNum<=3&&this.selectedNum>1) {
              var list = [];
              for(var i=0;i<this.list.length;i++){
                if(this.list[i].selected==1) {
                  list.push(this.list[i].sku8D);
                }
              }
              this.$router.push({path:'/CompareResult',query: {
                sku8Ds: list.join(',')//'P18913700,P18913800,P18913600'
              }})
            }else {
              alert('请选择2-3件产品')
            }

          }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Compare.vue